import { EventData } from 'xstate';

import { LogicContext } from '@/logic/main/types';
import { JackpotProvidersUnion } from '@/types/jackpotTypes';

export const updateJackpotsContent = async (
  context: LogicContext,
  event: EventData
) => {
  const { jackpots } = context;
  const updatedProviders =
    event.data?.data
      ?.map((item: unknown) =>
        typeof item === 'object' && item !== null && 'provider' in item
          ? item.provider
          : null
      )
      .filter(Boolean) || [];

  if (!jackpots) {
    return { updates: [] };
  }

  let updates = [];

  for (let provider of updatedProviders) {
    const jackpotsByCode = jackpots[provider as JackpotProvidersUnion];
    if (!jackpotsByCode) {
      continue;
    }
    for (const jackpot of Object.values(jackpotsByCode)) {
      if (
        !jackpot.components ||
        !jackpot.components.length ||
        !jackpot.fieldsValues
      ) {
        continue;
      }

      updates.push(
        ...jackpot.components.map((componentId: string) => ({
          type: 'setLayoutProperty',
          data: {
            path: `components.${componentId}.properties`,
            value: {
              feed: {
                ...jackpot.fieldsValues,
                timestamp: Date.now(),
              },
            },
          },
        }))
      );
    }
  }

  return { updates };
};
